module.exports = __webpack_public_path__ + "static/media/Sample_01.5a1890ef.mp4";